module.exports = __webpack_public_path__ + "static/media/ic_mail.a47fa07e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_mail.svg
// module id = 154
// module chunks = 0